import Head from 'next/head'
import Script from 'next/script'
import { getArticleDateTime } from '../../../utils/article-date-time';
import { Electrician } from '../../../components/index/service-category/handyman/Electrician';
import { electricianTestimonials } from '../../../data/CustomerReviewData';
import { buildBreadcrumb } from 'utils/breadcrumb'
import { buildServiceHubGraph } from 'utils/service-hub-schema'
import { formatPrice, fromPrice, loadHandymanCategorySettings, loadHandymanPriceList } from 'utils/handyman-price-data'
import { ELECTRICIAN_HUB } from 'data/handyman-job-pages'

const PAGE_URL = `https://www.stringssg.com${ELECTRICIAN_HUB}`
const OG_IMAGE = "https://stringssg-assets.s3-ap-southeast-1.amazonaws.com/static/handyman/electrician-installing-lights.jpg"

// This function gets called at build time on server-side.
// It may be called again, on a serverless function, if
// revalidation is enabled and a new request comes in
export async function getStaticProps() {
  const countryCd = "sg"
  const countryName = "Singapore"

  const { modifiedDate, month, year } = getArticleDateTime();

  // Both loaders fall back to a committed snapshot, so a failed API call can no
  // longer fail the build or leave ISR stuck on a stale page.
  const requestCategorySettings = await loadHandymanCategorySettings(countryName)
  const handymanPriceList = await loadHandymanPriceList(countryName)

  return {
      props: {
        requestCategorySettings,
        countryName,
        countryCd,
        modifiedDate,
        month,
        year,
        electricianTestimonials,
        handymanPriceList
      },
      revalidate: 259200, // In seconds
  }
}

export default function Home(props) {
  const requestCategorySettings = props.requestCategorySettings
  const countryName = props.countryName
  const modifiedDate = props.modifiedDate
  const testimonials = props.electricianTestimonials
  const handymanPriceList = props.handymanPriceList

  // Everything in the Electrical category, including heater jobs the API assigns
  // to a handyman. Same set as the electrician price page.
  const electricalItems = handymanPriceList
    .filter((item) => item.category === 'Electrical')
    .sort((a, b) => a.serviceCost - b.serviceCost)
  const from = formatPrice(fromPrice(electricalItems))

  // Targets "electrician singapore", "certified/licensed electrician",
  // "cheap electrician" and "electrician near me" without stuffing: the title
  // leads with the head term, and the description covers the modifiers.
  const title = `Electrician Singapore | Licensed, Same-Day, From ${from}`
  const description = `Licensed electrician near you in Singapore for power trips, wiring, lights, fans and DB boxes. Affordable fixed prices from ${from}, same-day slots.`

  const schema = buildServiceHubGraph({
    pageUrl: PAGE_URL,
    pageName: title,
    description,
    trail: buildBreadcrumb(ELECTRICIAN_HUB),
    items: electricalItems,
    serviceName: 'Electrician Services Singapore',
    serviceType: 'Electrician Service',
    image: OG_IMAGE,
    datePublished: '2025-01-01T07:30:46+00:00',
    modifiedDate,
  })

  return (
    <>
      <Head>
        <title>{title}</title>
        <meta charSet="utf-8"/>
        <meta httpEquiv="X-UA-Compatible" content="IE=edge"/>
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <meta name="description" content={description}/>
        <meta name="author" content="StringsSG"/>
        <meta name="google-site-verification"
            content="JAjj5vAc8Xxrh4idRAchZhYR6rwxWPAk3vxMdx-dwVQ" />
        <meta property="og:locale" content="en_US" />
        <meta property="og:url"  content={PAGE_URL} />
        <meta property="og:type"   content="website" />
        <meta property="og:title"    content={title}/>
        <meta property="og:description" content={description}/>
        <meta property="og:site_name" content="StringsSG" />
        <meta property="og:image"  content={OG_IMAGE} />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:site" content="@stringssg"/>
        <meta name="twitter:url" content={PAGE_URL}/>
        <meta name="twitter:title" content={title}/>
        <meta name="twitter:description" content={description}/>
        <meta name="twitter:image" content={OG_IMAGE} /><link rel="icon" href="/favicon.ico" />
        <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }} />
        <link rel="canonical" href={PAGE_URL} />
      </Head>
        <div>
            <Electrician requestCategorySettings={requestCategorySettings} countryName={countryName} testimonials={testimonials} handymanType="Electrician" handymanPriceList={handymanPriceList}/>
        </div>
        <Script
          id="google-tagmanager-new"
          src="https://www.googletagmanager.com/gtag/js?id=G-QD1HGGHDYJ"
          strategy="lazyOnload"
          onLoad={() => {
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());

            gtag('config', 'G-QD1HGGHDYJ');
          }}
        />
        <Script id="facebook-tracking" strategy="lazyOnload">
          {`!function(f,b,e,v,n,t,s)
            {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
            n.callMethod.apply(n,arguments):n.queue.push(arguments)};
            if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
            n.queue=[];t=b.createElement(e);t.async=!0;
            t.src=v;s=b.getElementsByTagName(e)[0];
            s.parentNode.insertBefore(t,s)}(window, document,'script',
            'https://connect.facebook.net/en_US/fbevents.js');
            fbq('init', '128634041116395');
            fbq('track', 'PageView');`}
        </Script>
    </>
  )
}
